import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { createSimulation, Simulation } from '../state/simulation.model';
import { SimulationService } from '../state/simulation.service';

@Component({
  selector: 'app-simulation',
  templateUrl: './simulation-form.component.html',
  styleUrls: ['./simulation-form.component.scss']
})
export class SimulationFormComponent implements OnInit {

  formGroup: FormGroup;
  isEditionMode: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public simulation: Simulation,
    private simulationService: SimulationService,
    private formBuilder: FormBuilder,
    private windowService: WindowService
  ) {
    if (!this.simulation) {
      this.simulation = createSimulation({});
      this.isEditionMode = false;
    } else {
      this.simulation = createSimulation(simulation);
      this.isEditionMode = true;
    }
  }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      name: [this.simulation.name, Validators.required]
    });
  }

  save() {
    this.simulation.name = this.formGroup.value.name;

    if (this.isEditionMode) {
      this.simulationService.update(this.simulation.id, this.simulation)
        .subscribe(s => {
          this.windowService.close(this);
        });
    } else {
      this.simulationService.add(this.simulation)
        .subscribe(s => {
          this.simulationService.active(s.id);
          this.windowService.close(this);
        });
    }
  }

}
